import { TypographyOptions } from "@mui/material/styles/createTypography";

export const CustomTypography: TypographyOptions = {
  fontFamily: "Montserrat",
  fontSize: 15,

  h1: {
    fontSize: 55,
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: 12
  },
  h2: {
    fontSize: 34,
    fontWeight: 800,
    margin: "4px 0 12px"
  },
  h3: {
    fontSize: 20,
    fontWeight: 700,
    margin: "4px 0"
  },
  h4: {
    fontSize: 13,
    fontWeight: 700,
    margin: "4px 0"
  },
  h5: {
    fontSize: 13,
    fontWeight: 500,
    margin: "4px 0"
  },
  subtitle1: {
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: 12
  },
  subtitle2: {
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal"
  }
};
